const accordionItems = document.querySelectorAll('.footer__accordion');

if (accordionItems.length > 0) {
  accordionItems.forEach(item => {
    const btn = item.querySelector('.footer__accordion-btn');
    if (!btn) return;

    btn.addEventListener('click', () => {
      if (window.innerWidth >= 1000) return;

      const isActive = item.classList.contains('is-active');

      accordionItems.forEach(i => i.classList.remove('is-active'));

      if (!isActive) {
        item.classList.add('is-active');
      }
    });
  });
}
